import { FieldSchema } from "../../../Schema";
import { GridFilterTypes } from "../../../grid/AgGridManager";

// Grid/table-only field (not part of the equipment form). Unlike the other
// positioning fields this one is sortable and included in quick search.
export const vibrationSensitive: FieldSchema = {
  name: "vibrationSensitive",
  // Read-only / additional-info field: fetched & displayed, but excluded from
  // create/update mutations (managed outside the schema equipment form).
  dataTransform: { toGraphql: undefined },
  grid: {
    displayed: true,
    order: 64,
    label: "Vibration sensitive",
    filter: GridFilterTypes.TEXT,
  },
};
